(function() {
  'use strict';

  function Slot(RouterHelper, HELPTEXTS, $translate) {
    return {
      restrict: 'A',
      template: '<div class="row row-bordered">' +
        '<div class="col-sm-12" ng-bind-html="helpText"></div>' +
      '</div>',
      link: function(scope) {
        function updateHelp() {
          const state = RouterHelper.getState();
          var text = HELPTEXTS[state];
          if (text) {
            $translate(text).then(function(translated) {
              scope.helpText = translated;
            }, function() {
              scope.helpText = text;
            });
          }
          scope.hidden = _.isUndefined(text);
        }
        updateHelp();

        scope.$on('routerEvents:NavigationEnd', function() {
          updateHelp();
        });
      }
    };
  }

  Slot.$inject = ['RouterHelperService', 'HELPTEXTS', '$translate'];

  angular.module('layout.sidebar')
    .directive('sidebarHelp', Slot);
})();
